module.exports = __webpack_public_path__ + "img/support.cacb43f.svg";